var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.34 39.08"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 10.45H17.31V0H77zm0 3.86H17.31v10.45H77zm0 14.32H17.31v10.45H77zm-66.49 0C1.08 16.48 8.1 0 8.1 0-7.17 15.29 3.84 35.32 3.84 35.32L.08 39.08h14.08V25zM83.8 10.45c9.45 12.15 2.43 28.63 2.43 28.63C101.51 23.79 90.5 3.76 90.5 3.76L94.25 0H80.18v14.08z"
  })));
}
export default SvgSwap;